import React, { useCallback, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import aifSubmissionsService from '../../services/claim/aif_submissions.service';
import { useTranslation } from 'react-i18next';
const NoHmrc = _ref => {
  let {
    claimId,
    isFisrstSubmission,
    setAifReportCreationIdString,
    onAifSubmission,
    aif_claim_type,
    disabled
  } = _ref;
  const [loading, setLoading] = useState(false);
  const createAifSubmission = aifSubmissionsService.useCreate({
    claimId,
    setAifReportCreationIdString,
    setLoading,
    onSuccess: onAifSubmission,
    aif_claim_type
  });
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Button, {
    tooltipText: disabled ? 'Please fix the issues listed below before submitting.' : '',
    className: "mb-4",
    loading: loading,
    disabled: disabled,
    onClick: createAifSubmission,
    size: "md",
    variant: "primary",
    iconPosition: "left"
  }, isFisrstSubmission ? t('start_an_aif_submission') : t('start_another_aif_submission'))));
};
export default NoHmrc;